import IsirAPI from "../apis/IsirAPI";
import AlertService from "./AlertService";

class IsirService {
  async IsirRecordSearch(isirRecord) {
    const resp = await IsirAPI.post("IsirRecord/search/", isirRecord);
    return resp.data;
  }

  async getAllIsirHeader() {
    const resp = await IsirAPI.get(`IsirHeader/`);
    return resp.data;
  }
  async getOneIsirHeader(id) {
    const resp = await IsirAPI.get(`IsirHeader/${id}`);
    return resp.data;
  }

  async processIsirFile(formData) {
    try {
      const resp = await IsirAPI.post(`isir/uploadIsir`, formData);
      return resp;
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  //change to by school and year
  async getIsirViewBySchoolAndYear(schoolCode, aidYear, includeMaster, includeSchool = true) {
    let url = `IsirView/GetIsirViewBySchoolAndYear/${schoolCode}/${aidYear}/${includeMaster}/${includeSchool}`;

    const resp = await IsirAPI.get(url);
    if(resp.status === 204){
      return resp.status;
    } else {
      return resp.data;
    }
  }

  //isirViewElement
  async updateIsirViewElementSortOrder(params) {
    try {
      const resp = await IsirAPI.post(
        `IsirViewElement/updateIsirViewElementSortOrder`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Update ISIR view element sort order failed");
    }
  }

  async masterUpdateIsirViewElementSortOrder(params) {
    try {
      const resp = await IsirAPI.post(
        `MasterIsirViewElement/updateIsirViewElementSortOrder`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Update ISIR view element sort order failed");
    }
  }

  async updateIsirViewGroupSortOrder(params) {
    try {
      const resp = await IsirAPI.post(
        `IsirViewGroup/updateIsirViewGroupSortOrder`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Update ISIR view group sort order failed");
    }
  }

  async deleteIsirViewElement(id) {
    try {
      const resp = await IsirAPI.delete(`IsirViewElement/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Element could not be deleted");
    }
  }

  async deleteAndUpdateIsirViewElementSortOrderAsync(id) {
    try {
      const resp = await IsirAPI.post(`IsirViewElement/deleteAndUpdateIsirViewElementSortOrder/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Element could not be deleted");
    }
  }

  async addIsirViewElement(isirViewElement) {
    try {
      const resp = await IsirAPI.post(`IsirViewElement/`, isirViewElement);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view element add failed");
    }
  }

  async masterAddIsirViewElement(isirViewElement) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewElement/`, isirViewElement);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view element add failed");
    }
  }

  async updateIsirViewElement(isirViewElement) {
    try {
      const resp = await IsirAPI.patch(`IsirViewElement/${isirViewElement.id}`, isirViewElement);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view element update failed");
    }
  }

  async searchIsirViewElement(isirViewElement) {
    try {
      const resp = await IsirAPI.post(
        `IsirViewElement/search`,
        isirViewElement
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view element search failed");
    }
  }

  async masterSearchIsirViewElement(isirViewElement) {
    try {
      const resp = await IsirAPI.post(
        `MasterIsirViewElement/search`,
        isirViewElement
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view element search failed");
    }
  }

  //isirViewGroup
  async searchIsirViewGroup(isirViewGroup) {
    try {
      const resp = await IsirAPI.post(`IsirViewGroup/search`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group search failed");
    }
  }

  async isirViewGroupDelete(editDefaultsSettings, id){
    let resp;
    if(editDefaultsSettings){
      resp = await this.deleteMasterIsirViewGroup(id);
    } else {
      resp = await this.deleteIsirViewGroup(id);
    }

    return resp;
  }

  async isirViewGroupSearch(editDefaultsSettings, isirViewGroup) {
    let resp;
    if (editDefaultsSettings) {
      resp = await this.masterSearchIsirViewGroup(isirViewGroup);
    } else {
      resp = await this.searchIsirViewGroup(isirViewGroup);
    }

    return resp;
  }


  async masterSearchIsirViewGroup(isirViewGroup) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewGroup/search`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group search failed");
    }
  }

  async deleteMasterIsirViewGroup(id) {
    try {
      const resp = await IsirAPI.delete(`MasterIsirViewGroup/deleteMasterIsirViewGroup/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Group could not be deleted");
    }
  }


  async deleteIsirViewGroup(id) {
    try {
      const resp = await IsirAPI.delete(`IsirViewGroup/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Group could not be deleted");
    }
  }

  async addIsirViewGroup(isirViewGroup) {
    try {
      const resp = await IsirAPI.post(`IsirViewGroup/`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group add failed");
    }
  }

  async masterAddIsirViewGroup(isirViewGroup) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewGroup/`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group add failed");
    }
  }

  async masterDeleteIsirViewElement(id) {
    try {
      const resp = await IsirAPI.delete(`MasterIsirViewElement/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Element could not be deleted");
    }
  }

  async masterDeleteAndUpdateIsirViewElementSortOrderAsync(id) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewElement/deleteAndUpdateIsirViewElementSortOrder/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Element could not be deleted");
    }
  }

  async IsirViewGroupUpdate(editDefaultsSettings, ID, isirViewGroup){
    let resp;
    if(editDefaultsSettings){
      resp = await this.masterUpdateIsirViewGroup(ID, isirViewGroup);
    } else {
      resp = await this.updateIsirViewGroup(ID, isirViewGroup);
    }
    return resp;
  }

  async updateIsirViewGroup(ID, isirViewGroup) {
    try {
      const resp = await IsirAPI.patch(`IsirViewGroup/${ID}`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group update failed");
    }
  }

  async masterUpdateIsirViewGroup(ID, isirViewGroup) {
    try {
      const resp = await IsirAPI.patch(`MasterIsirViewGroup/${ID}`, isirViewGroup);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view group update failed");
    }
  }

  //isirViewTab
  async deleteIsirViewTab(id) {
    try {
      const resp = await IsirAPI.delete(`IsirViewTab/${id}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Tab could not be deleted");
    }
  }

  async addIsirViewTab(isirViewTab) {
    try {
      const resp = await IsirAPI.post(`IsirViewTab/`, isirViewTab);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab add failed");
    }
  }

  async masterAddIsirViewTab(isirViewTab) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewTab/`, isirViewTab);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab add failed");
    }
  }

  async updateIsirViewTab(ID, isirViewTab) {
    try {
      const resp = await IsirAPI.patch(`IsirViewTab/${ID}`, isirViewTab);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab update failed");
    }
  }

  async searchIsirViewTab(isirViewTab) {
    try {
      const resp = await IsirAPI.post(`IsirViewTab/search`, isirViewTab);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab search failed");
    }
  }

  async masterSearchIsirViewTab(isirViewTab) {
    try {
      const resp = await IsirAPI.post(`MasterIsirViewTab/search`, isirViewTab);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab search failed");
    }
  }

  async isirViewGroupUpdateSortOrder(editDefaultsSettings, params) {
    let resp;
    if (editDefaultsSettings) {
      resp = await this.masterUpdateIsirViewGroupSortOrder(params);
    } else {
      resp = await this.updateIsirViewGroupSortOrder(params);
    }

    return resp;
  }

  async masterUpdateIsirViewGroupSortOrder(params) {
    try {
      const resp = await IsirAPI.post(
        `MasterIsirViewGroup/updateMasterIsirViewGroupSortOrder`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Update ISIR view group sort order failed");
    }
  }
  async updateIsirViewTabSortOrder(params) {
    try {
      const resp = await IsirAPI.post(
        `IsirViewTab/updateIsirViewTabSortOrder`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view tab sort order update failed");
    }
  }

  //isirViewTab + isirViewGroup + isirViewElement
  async addIsirViewSettings(isirViewSettings) {
    try {
      const resp = await IsirAPI.post(
        `IsirView/addIsirViewSettings`,
        isirViewSettings
      );
      AlertService.addSuccessAlert("ISIR View Settings copied");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("ISIR View Settings could not be copied");
    }
  }

  async rolloverIsirViewSettings(aidYear) {
    try {
      const resp = await IsirAPI.post(
        `IsirView/rolloverIsirViewSettings/${aidYear}`, {}
      );
      AlertService.addSuccessAlert("ISIR View Settings copied");
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("ISIR View Settings could not be copied");
    }
  }

  async searchStudentRepository(searchFilters) {
    try {
      const resp = await IsirAPI.post(
        `studentrepository/search`,
        searchFilters
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view copy tab failed");
    }
  }

  async searchStudentRepositoryIDs(searchFilters) {
    try {
      const resp = await IsirAPI.post(
        'studentrepository/searchIDs', searchFilters);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository search failed");
    }
  }

  async getManyStudentRepository(ids) {
    try {
      const resp = await IsirAPI.post(
        'studentrepository/getManyByIDs', ids);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository get many failed");
    }
  }

  async importRepoRecords({ selectedRows }, aidYear ) {
    try {
      const resp = await IsirAPI.post(`studentrepository/processStudRepoIntoVG/${aidYear}`, selectedRows);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.response?.data ?? err?.message);
    }
  }

  async studentRepositoryErrorReport(params) {
    try {
      const resp = await IsirAPI.post(
        `studentrepositoryTransferRecord/StudentRepositoryTransferRecordReport`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository transfer record report failed");
    }
  }

  async studentRepositoryTransferFileHeader(params) {
    try {
      const resp = await IsirAPI.post(
        `StudentRepositoryTransferFileHeader/StudentRepositoryTransferHeaderReport`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository transfer header report failed");
    }
  }

  async studentRepositoryTransferRecordSearch(params) {
    try {
      const resp = await IsirAPI.post(
        `studentrepositoryTransferRecord/searchbylists`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository transfer record search failed");
    }
  }

  async studentRepositorySearch(params) {
    try {
      const resp = await IsirAPI.post(
        `studentrepository/searchbylists`,
        params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "Student Repository search by lists failed");
    }
  }

  async copyIsirViewTab(params) {
    try {
      const resp = await IsirAPI.post(`isirview/copyisirviewtab`,
      params
      );
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert(err?.message ?? "ISIR view copy tab failed");
    }
  }

  async getOneIsirViewTab(id) {
    const resp = await IsirAPI.get(`IsirViewTab/${id}`);
    return resp.data;
  }

  async studentAccountLookup(studentID, accountType) {
    try {
      const resp = await IsirAPI.get(`isir/studentAccountLookup/${studentID}/${accountType}`);
      return resp.data;
    } catch (err) {
      AlertService.addErrorAlert("Student account lookup failed");
    }
  }

  
  async downloadStudentRepoTransferFile(schoolCode, headerFileID) {
    try {
      const resp = await IsirAPI.get(
        "studentRepositoryTransferFileHeader/DownloadTransferFile/" + schoolCode + "/" + headerFileID
      );
      return resp.data;
    } catch (err) {
        AlertService.addErrorAlert("Download of Student Repo Transfer file failed");
    }
  }

}

let instance = new IsirService();
export default instance;
